import { z } from 'zod';

export function getPixels(value: any, options?: { allowUndefined: boolean }) {
  if (options?.allowUndefined && ['', undefined, null].includes(value)) {
    return undefined;
  }
  return z.coerce
    .number()
    .catch(0)
    .transform((val) => `${val}px`)
    .parse(value);
}

export function getColor(value: any, options?: { allowUndefined: boolean }) {
  if (options?.allowUndefined) return value || undefined;

  return value || 'transparent';
}

export function getUrl(value: any, options?: { allowUndefined: boolean }) {
  const cssValue = `url('${value}')`;

  if (options?.allowUndefined) return cssValue || undefined;

  return cssValue || '';
}

export function getAspectRatio(value: any) {
  const regex = /\s*(\d+)\s*x\s*(\d+)\s*/;
  return z
    .string()
    .regex(regex)
    .nullable()
    .catch(null)
    .transform((val) => {
      if (!val) return undefined;
      const matches: any = val.match(regex);
      return `${matches[1]} / ${matches[2]}`;
    })
    .parse(value);
}
